import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx } from "vue";
import { app } from "@/di";
import ActionScreener from "@/modules/action-screens/services/ActionScreener";
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionScreenContainer',
  setup(__props) {
    const actionScreener = app.get(ActionScreener);
    const {
      visible,
      component,
      props
    } = actionScreener;
    const screen = ref(null);
    const onAfterEnter = () => {
      if (screen.value && screen.value.onEnter) {
        screen.value.onEnter();
      }
    };
    const onAfterLeave = () => {
      if (screen.value && screen.value.onLeave) {
        screen.value.onLeave();
      }
    };
    return (_ctx, _cache) => {
      const _component_NModal = _resolveComponent("NModal");
      return _openBlock(), _createBlock(_component_NModal, {
        show: _unref(visible),
        "onUpdate:show": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        preset: "dialog",
        "show-icon": false,
        closable: false,
        "mask-closable": false,
        "on-after-enter": onAfterEnter,
        "on-after-leave": onAfterLeave
      }, {
        default: _withCtx(() => [_unref(component) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), _mergeProps({
          key: 0,
          ref_key: "screen",
          ref: screen
        }, _unref(props), {
          onFinished: _cache[0] || (_cache[0] = () => _unref(actionScreener).close())
        }), null, 16)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show"]);
    };
  }
});